const MAX_TOTAL_DISMISSALS = 4;
const FOURTEEN_DAYS_MS = 14 * 24 * 60 * 60 * 1000;
const DEFER_COUNT = 3;
const APP_TEXT = 'Sephora App';
const SUCCESS_DISPLAY_TIME_MS = 2000;
const PASSKEY_EXPIRED_ERROR_CODE = 'ERR_PK_EXPIRED';
const ERR_PK_LOGIN_ERROR = 'ERR_PK_LOGIN_ERROR';

export {
    MAX_TOTAL_DISMISSALS, FOURTEEN_DAYS_MS, DEFER_COUNT, APP_TEXT, SUCCESS_DISPLAY_TIME_MS, PASSKEY_EXPIRED_ERROR_CODE, ERR_PK_LOGIN_ERROR
};
